export default __webpack_public_path__ + "static/media/2029.282ba154.png";